var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":_vm.show}},[_vm._v(_vm._s(_vm.title))]),_c('popup-modal',{ref:"modal",attrs:{"show":_vm.showModal},on:{"close":_vm.hide}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }